import React from "react";

import Sliderhome from "./Utils/Sliderhome";
import Most from "./Utils/Most";
import Building from "./Utils/Building";

import budynek1 from "../assets/img/about/budynek1.jpg";
import budynek2 from "../assets/img/about/budynek2.jpg";
import miniaturka1 from "../assets/img/about/miniaturka1.jpg";
import miniaturka2 from "../assets/img/about/miniaturka2.jpg";

export default function Main() {
  return (
    <>
      <main>
        <Sliderhome />
        <Most>
          <div
            className="about-content s-about-content  wow fadeInRight"
            data-animation="fadeInRight"
            data-delay="3s"
            style={{textAlign: "justify"}}
          >
            <div className="about-title second-title pb-25">
              <h1 className="display-2">Słoneczne Podgórze</h1>
            </div>
            <p>
              Jest takie miejsce wśród zielonych Gór Orlickich gdzie blask
              słonecznych promieni ogrzewa południowy stok, a z nim pensjonat z
              szerokim widokiem na pasące się konie. Z drugiej strony góry las
              przynosi wytchnienie cieniem i spokój szumem strumyka. Mało jest
              miejsc gdzie noc zachwyca taką ilością gwiazd.
            </p>
            <p>
              Zapraszamy Państwa na wypoczynek do Dusznik-Zdroju dzielnicy
              Podgórze w Pensjonacie, którego historia sięga lat 20. XX wieku.
            </p>
          </div>
        </Most>
        <Building
          title={"Budynek A"}
          imageSrc1={budynek1}
          imageSrc2={miniaturka1}
          imagePosition={"left"}
          fadeIn={true}
        >
          <p style={{ textAlign: "justify", textJustify: "auto" }}>
            Stanowi serce naszego pensjonatu. Wnętrze zostało zaprojektowane z
            myślą o komforcie i relaksie naszych gości. Centralnym punktem jest
            przestronna jadalnia, gdzie serwujemy wyśmienite dania. Tuż obok
            znajduje się nasza duża sala rekreacyjna, która jest prawdziwym
            klejnotem tego miejsca. Z okien rozpościera się zapierający dech w
            piersiach widok na majestatyczną górę Graniczną. To idealne miejsce
            na relaks z dala od codziennego zgiełku. Dla miłośników literatury
            przygotowaliśmy przytulną biblioteczkę. To ciche i spokojne miejsce,
            idealne do zatopienia się w lekturze. Dodatkowo, dla tych, którzy
            szukają rozrywki, oferujemy kącik gier. Znajdą tu Państwo różnorodne
            gry planszowe i karciane, które zapewnią doskonałą zabawę zarówno
            dorosłym, jak i dzieciom. Budynek oferuje również cztery komfortowo
            urządzone pokoje, każdy z nich zaprojektowany z myślą o zapewnieniu
            maksymalnego komfortu i relaksu. Pokoje łączą w sobie elegancję i
            funkcjonalność, co sprawia, że pobyt w ośrodku zawsze będzie
            niezapomnianym przeżyciem.
          </p>
        </Building>
        <Building
          title={"Budynek B"}
          imageSrc1={budynek2}
          imageSrc2={miniaturka2}
          imagePosition={"right"}
          fadeIn={true}
        >
          <p style={{ textAlign: "justify", textJustify: "auto" }}>
            Oaza spokoju i relaksu, oferująca dwanaście starannie
            zaprojektowanych pokoi. Każdy pokój w tym budynku jest synonimem
            komfortu, zapewniając idealne warunki do odpoczynku po dniu pełnym
            wrażeń. Pokoje zostały wyposażone z myślą o różnorodnych potrzebach
            naszych gości. Dodatkowo, dla zapewnienia pełnego komfortu, każdy
            pokój wyposażony jest w nowoczesne udogodnienia, takie jak szybki
            dostęp do Internetu i prywatna łazienka z wysokiej klasy armaturą.
            Oświetlenie i dodatki tworzą ciepłą i przytulną atmosferę,
            sprzyjającą odprężeniu. W tym budynku każdy znajdzie coś dla siebie,
            niezależnie od tego, czy szuka miejsca na romantyczny weekend,
            rodzinne wakacje czy służbowy wyjazd. Nasz personel jest zawsze do
            Państwa dyspozycji, aby zapewnić niezapomniane wrażenia i komfortowy
            pobyt.
          </p>
        </Building>
      </main>
    </>
  );
};
